// @ts-nocheck
import { useEffect, useState, useMemo } from "react";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import { FaCheckCircle, FaDownload, FaSpinner } from "react-icons/fa";
import "./HistoryPayment.css";
import {
  getHistoricoAcaoComprovanteDespesa,
  downloadDespesaExtratoArquivoEvento,
} from "../../../services/FinanceiroService";

const formatDateTime = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value);
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}`;
};

const normalizeHistoryItem = (x, i = 0) => {
  const arquivoRaw = x?.arquivoId ?? x?.ArquivoId ?? null;
  const arquivoNum = Number(arquivoRaw);
  const arquivoId =
    arquivoRaw != null && Number.isFinite(arquivoNum) && arquivoNum > 0
      ? arquivoNum
      : null;

  return {
    acao: x?.acao ?? x?.titulo ?? x?.nome ?? "-",
    data: x?.data ?? x?.dataHora ?? x?.criadoEm ?? x?.createdAt ?? null,
    id: x?.id ?? i,
    arquivoId,
  };
};

const HistoryPayment = ({
  show,
  onHide,
  idSindicato,
  historyDataExtract = null,
}) => {
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [downloadingId, setDownloadingId] = useState(null);

  const externalData = useMemo(
    () => (Array.isArray(historyDataExtract) ? historyDataExtract : null),
    [historyDataExtract],
  );

  const hasArquivoColumn = useMemo(
    () => history.some((item) => item?.arquivoId != null),
    [history],
  );

  useEffect(() => {
    let alive = true;

    const fetchData = async () => {
      if (!show) return;

      if (externalData) {
        const normalized = externalData.map((x, i) => normalizeHistoryItem(x, i));
        setHistory(normalized);
        return;
      }

      if (!idSindicato) {
        setHistory([]);
        return;
      }

      setLoading(true);
      const data = await getHistoricoAcaoComprovanteDespesa(idSindicato);

      if (alive) {
        const normalized = Array.isArray(data)
          ? data.map((x, i) => normalizeHistoryItem(x, i))
          : [];

        setHistory(normalized);
        setLoading(false);
      }
    };

    fetchData();
    return () => {
      alive = false;
    };
  }, [show, idSindicato, externalData]);

  const handleDownload = async (item) => {
    const arquivoId = item?.arquivoId;
    if (arquivoId == null) return;

    try {
      setDownloadingId(arquivoId);
      await downloadDespesaExtratoArquivoEvento(
        arquivoId,
        `comprovante_evento_${arquivoId}.pdf`,
      );
    } catch (err) {
      console.error("Erro ao baixar arquivo do histórico:", err);
    } finally {
      setDownloadingId(null);
    }
  };

  const colSpan = hasArquivoColumn ? 3 : 2;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="payment-history-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="modal-title w-100 text-center">
          HISTÓRICO DO COMPROVANTES
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Table bordered responsive className="payment-history-table">
          <thead>
            <tr>
              <th>AÇÃO</th>
              <th>DATA/HORA</th>
              {hasArquivoColumn ? <th>ARQUIVO</th> : null}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={colSpan} className="text-center py-3">
                  <Spinner animation="border" size="sm" className="me-2" />{" "}
                  Carregando...
                </td>
              </tr>
            ) : history.length === 0 ? (
              <tr>
                <td colSpan={colSpan} className="text-center py-3">
                  Nenhum registro encontrado.
                </td>
              </tr>
            ) : (
              history.map((item, index) => {
                const isDownloading = downloadingId === item?.arquivoId;
                return (
                  <tr key={`${item?.id ?? index}`}>
                    <td className="text-start">
                      <FaCheckCircle className="icon-check" />{" "}
                      {item?.acao ?? "-"}
                    </td>
                    <td className="text-start">{formatDateTime(item?.data)}</td>
                    {hasArquivoColumn ? (
                      <td className="text-start">
                        {item?.arquivoId != null ? (
                          <button
                            type="button"
                            className="btn btn-link p-0 payment-history-download"
                            title="Baixar arquivo"
                            disabled={isDownloading}
                            onClick={() => handleDownload(item)}
                          >
                            {isDownloading ? (
                              <FaSpinner className="spin" />
                            ) : (
                              <FaDownload />
                            )}{" "}
                            Baixar
                          </button>
                        ) : (
                          <span className="text-muted">—</span>
                        )}
                      </td>
                    ) : null}
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>

        <div className="text-center mt-3">
          <Button className="btn-ok" onClick={onHide}>
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default HistoryPayment;
